import { useState } from 'react'
import Header from '../../../../customs/Header'
import SettingsModal from '../Modal/settingsCustomModal';
import CreateScoreType from './CreateScoreType';
import ScoreTypeContent from './ScoreTypeContent';

export default function Main() {
  const [createCountry, setCreateCountry] = useState(false);

  const handleOpenCreateCountry = () => setCreateCountry(true);
  const handleCloseCreateCountry = () => setCreateCountry(false);

  return (
    <section>
      <Header props={
      { 
        firstName: 'All', 
        secondName: 'Score Type', 
        buttonText: 'Create Score Type', 
      }}
      handleOpen={handleOpenCreateCountry}
    />

    <ScoreTypeContent />
    
    <SettingsModal 
      open={createCountry}
      cancel={handleCloseCreateCountry}
      maxWidth='480px'
      header={'Create Score Type'}
      showrightIcon={false}
      content={<CreateScoreType handleClose={handleCloseCreateCountry}/>}
    />
    </section>
    
  )
}



